export default __webpack_public_path__ + "static/media/box-2.4bb27900.png";